import { Box, Button, Checkbox, Dialog, DialogActions, DialogContent, DialogContentText, FormControl, FormControlLabel, FormHelperText, IconButton, InputLabel, LinearProgress, MenuItem, Select, TextField, Tooltip, useMediaQuery } from '@mui/material'
import React, { useEffect } from 'react'
import DisplaySettingsIcon from '@mui/icons-material/DisplaySettings';
import { useTheme } from '@mui/material/styles';
import InsertPhotoOutlinedIcon from '@mui/icons-material/InsertPhotoOutlined';
import OpenInNewIcon from '@mui/icons-material/OpenInNew';
import MessageOutlinedIcon from '@mui/icons-material/MessageOutlined';
import SaveOutlinedIcon from '@mui/icons-material/SaveOutlined';
import CloseOutlinedIcon from '@mui/icons-material/CloseOutlined';
import VisibilityOutlinedIcon from '@mui/icons-material/VisibilityOutlined';

import QrCodeScannerIcon from '@mui/icons-material/QrCodeScanner';
import { MainDialogTitle } from '../../ReuseComponents/MainDialogTitle';
import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import useAxiosPrivate from '../../../CustomHooks/useAxiosPrivate';
import useAuth from '../../../CustomHooks/useAuth';
import { Link } from 'react-router-dom';
import { FormattedMessage, useIntl } from 'react-intl';

export const PostSurveySettings = () => {
    const axiosPrivate = useAxiosPrivate();
    const intl = useIntl();
    const { defaultCustomer } = useAuth();
    const queryClient = useQueryClient();
    const queryParams = new URLSearchParams(window.location.search);
    const survey = queryParams.get("survey");
    const theme = useTheme();
    const [open, setOpen] = React.useState(false);
    // const handleOpen = () => setOpen(true);
    const handleClose = () => setOpen(false);
    const fullScreen = useMediaQuery(theme.breakpoints.down('sm'));

    const [selectedPostSurvey, setSelectedPostSurvey] = React.useState('');
    const [orderValue, setOrderValue] = React.useState('');
    const [personalInfo, setPersonalInfo] = React.useState(false);
    const [requiredPersonalInfo, setRequiredPersonalInfo] = React.useState(false);
    const [hands, setHands] = React.useState(false);
    const [postSurveyName, setPostSurveyName] = React.useState('');

    const [imageLink, setImageLink] = React.useState('');
    const [redirectLink, setRedirectLink] = React.useState('');
    const [message, setMessage] = React.useState('');
    const [qrLink, setQrLink] = React.useState('');

    const [isSending, setIsSending] = React.useState(false);

    const { data: allPostSurveyInfo } = useQuery({
        queryKey: ['AllPostSurvey'],
        queryFn: async () => {
            const response = await axiosPrivate.get(`postsurvey/all?customer=${defaultCustomer}`);
            if (!response.data?.text) {
                return response.data;
            }
        },
        onError: (error) => {
            console.error(error.message);
        },
        refetchOnWindowFocus: false,
        retry: false,
    });

    const { data: postSurveyInfo } = useQuery({
        queryKey: ['postsurvey', survey],
        queryFn: async () => {
            const response = await axiosPrivate.get(`postsurvey/info/${survey}?customer=${defaultCustomer}`);
            if (!response.data?.text) {
                return response.data;
            }
        },
        onError: (error) => {
            // if (error.response?.status === 404) {
            //     // console.error("No se encontró el cliente");
            //     setErrorMsg(intl.formatMessage({ id: "survey.not.found.msg" }));
            // } else if (error.response?.status === 409) {
            //     setErrorMsg(intl.formatMessage({ id: "survey.end.trial.msg" }));
            // }
            // else {
            //     console.error(error.message);
            // }
            console.error(error.message);
        },
        refetchOnWindowFocus: false,
        retry: false,
    });

    useEffect(() => {
        if (postSurveyInfo) {
            setImageLink(postSurveyInfo.img_link || '');
            setRedirectLink(postSurveyInfo.open_image_link || '');
            setMessage(postSurveyInfo.message || '');
            setQrLink(postSurveyInfo.qr_link || '');
            setPersonalInfo(postSurveyInfo.personal_info || false);
            setRequiredPersonalInfo(postSurveyInfo.required_personal_info || false);
            setHands(postSurveyInfo.numeric_hand || false);
            setOrderValue(postSurveyInfo.number_order || '');
            setSelectedPostSurvey(postSurveyInfo.id);
        }
    }, [postSurveyInfo]);

    const createPostSurveyMutation = useMutation({
        mutationFn: async (values) => {
            setIsSending(true);
            const response = await axiosPrivate.post(
                `postsurvey/info/${survey}?customer=${defaultCustomer}`,
                values
            )
            return response.data;
        },
        onSuccess: (data, values) => {
            
            queryClient.invalidateQueries({ queryKey: ['postsurvey', survey], exact: true });
            queryClient.invalidateQueries({ queryKey: ['AllPostSurvey'], exact: true });
            alert(intl.formatMessage({ id: "post.survey.success" }))
        },
        onError: (error) => {
            console.error(error);
            alert(intl.formatMessage({ id: "post.survey.error" }))
        },
        onSettled: () => {
            setIsSending(false);
        }
    });

    const updatePostSurveyMutation = useMutation({
        mutationFn: async (values) => {
            setIsSending(true);
            const response = await axiosPrivate.put(
                `postsurvey/info/${survey}?customer=${defaultCustomer}`,
                values
            )
            return response.data;
        },
        onSuccess: (data, values) => {
            queryClient.invalidateQueries({ queryKey: ['postsurvey', survey], exact: true });
            queryClient.invalidateQueries({ queryKey: ['AllPostSurvey'], exact: true });
            alert(intl.formatMessage({ id: "post.survey.update.success" }))
        },
        onError: (error) => {
            console.error(error);
            alert(intl.formatMessage({ id: "post.survey.update.error" }))
        },
        onSettled: () => {
            setIsSending(false);
        }
    });

    const handleSelectedPostSurvey = (e) => {
        setSelectedPostSurvey(e.target.value);
        const selectedPostSurveyInfo = allPostSurveyInfo?.find(postSurvey => postSurvey.id === e.target.value);
        if (selectedPostSurveyInfo) {
            setImageLink(selectedPostSurveyInfo.img_link || '');
            setRedirectLink(selectedPostSurveyInfo.open_image_link || '');
            setMessage(selectedPostSurveyInfo.message || '');
            setQrLink(selectedPostSurveyInfo.qr_link || '');
            setPersonalInfo(selectedPostSurveyInfo.personal_info || false);
            setRequiredPersonalInfo(selectedPostSurveyInfo.required_personal_info || false);
            setHands(selectedPostSurveyInfo.numeric_hand || false);
            setOrderValue(selectedPostSurveyInfo.number_order || '');
        } else {
            setImageLink('');
            setRedirectLink('');
            setMessage('');
            setQrLink('');
            setPersonalInfo(false);
            setRequiredPersonalInfo(false);
            setHands(false);
            setOrderValue('');
        }
    }

    const handlePreview = () => {
        const postSurveyData = {
            orderValue,
            personalInfo,
            requiredPersonalInfo,
            hands,
            imglink: imageLink || null,
            openImageLink: redirectLink || null,
            postSurveyMsg: message || null,
            qr: qrLink || null,
            postSurveyName: postSurveyName || null,
            videoInfo: null,
            selectedPostSurvey,
            post_survey_theme: null,
        }
        //save sessionStorage
        localStorage.setItem('postSurveyData', JSON.stringify(postSurveyData));
    }

    const handleSubmit = (e) => {
        e.preventDefault();
        if (selectedPostSurvey === '' && postSurveyName === '') {
            return alert(intl.formatMessage({ id: "post.survey.name.error" }));
        }
        const values = {
            orderValue,
            personalInfo,
            requiredPersonalInfo,
            hands,
            imageLink,
            redirectLink,
            message,
            qrLink,
            postSurveyName,
            selectedPostSurvey
        }
        //check if any string is empty '' change to null
        for (const key in values) {
            if (typeof values[key] === 'string' && values[key].trim() === '') {
                values[key] = null;
            }
        }
        if (selectedPostSurvey === '') {
            createPostSurveyMutation.mutate(values);
        } else {
            updatePostSurveyMutation.mutate(values);
        }
        //delete localStorage
        localStorage.removeItem('postSurveyData');
    }

    return (
        <div>
            <Tooltip title={"Settings"} arrow>
                <IconButton
                    size="large"
                    aria-controls="menu-appbar"
                    aria-haspopup="true"
                    onClick={() => setOpen(!open)}
                    color="inherit"
                >
                    <DisplaySettingsIcon />
                </IconButton>
            </Tooltip>
            <Dialog
                open={open}
                onClose={handleClose}
                fullScreen={fullScreen}
                maxWidth={'md'}
            >
                <MainDialogTitle id="responsive-dialog-title" className="text-center" onClose={handleClose}>
                    <FormattedMessage id="post.survey.settings" />
                    <hr />
                </MainDialogTitle>
                {/* <DialogTitle>
                    
                    <hr />
                </DialogTitle> */}
                <DialogContent>
                    <DialogContentText className='mb-3'>
                        <FormattedMessage id="post.survey.settings.description" />
                    </DialogContentText>
                    <FormControl
                        sx={{ marginTop: 0, marginLeft: 'auto', width: '100%' }}
                        size="small"
                    >
                        <InputLabel id="createdPost">
                            <FormattedMessage id="post.survey.already.created" />
                        </InputLabel>
                        <Select
                            labelId="createdPost"
                            id="createdPost"
                            label={<FormattedMessage id="post.survey.already.created" />}
                            value={selectedPostSurvey}
                            onChange={handleSelectedPostSurvey}
                        >
                            <MenuItem value="">
                                <em><FormattedMessage id="none" /></em>
                            </MenuItem>
                            {allPostSurveyInfo?.map((postSurvey) => (
                                <MenuItem key={postSurvey.id} value={postSurvey.id}>
                                    {postSurvey.post_survey_name}
                                </MenuItem>
                            ))}
                        </Select>
                        <FormHelperText>
                            <FormattedMessage id="post.survey.already.created.description" />
                        </FormHelperText>
                    </FormControl>
                    <Box display="flex" alignItems="flex-start">
                        <FormControl component="fieldset" variant="standard">
                            <FormControlLabel
                                label={<FormattedMessage id="post.survey.personal.info" />}
                                control={
                                    <Checkbox
                                        checked={personalInfo}
                                        onChange={(e) => setPersonalInfo(e.target.checked)}
                                    />
                                }
                            />
                            <FormControlLabel
                                label={<FormattedMessage id="post.survey.personal.info.required" />}
                                control={
                                    <Checkbox
                                        checked={requiredPersonalInfo}
                                        onChange={(e) => setRequiredPersonalInfo(e.target.checked)}
                                    />
                                }
                            />
                            <FormControlLabel
                                label={<FormattedMessage id="post.survey.hands" />}
                                control={
                                    <Checkbox
                                        checked={hands}
                                        onChange={(e) => setHands(e.target.checked)}
                                    />
                                }
                            />
                        </FormControl>
                        <FormControl
                            sx={{ marginTop: 0, marginLeft: 'auto', width: 'auto' }}
                            size="small"
                        >
                            <InputLabel id="optionOrder">
                                <FormattedMessage id="post.survey.options.order" />
                            </InputLabel>
                            <Select
                                labelId="optionOrder"
                                id="OptionOrder"
                                label={<FormattedMessage id="post.survey.options.order" />}
                                value={orderValue}
                                onChange={(e) => setOrderValue(e.target.value)}
                            >
                                <MenuItem value="">
                                    <em><FormattedMessage id="none" /></em>
                                </MenuItem>
                                <MenuItem value={'asc'}>
                                    <FormattedMessage id="post.survey.options.order.asc" />
                                </MenuItem>
                                <MenuItem value={'desc'}>
                                    <FormattedMessage id="post.survey.options.order.desc" />
                                </MenuItem>
                            </Select>
                            <FormHelperText>
                                <FormattedMessage id="post.survey.options.order.description" />
                            </FormHelperText>
                        </FormControl>
                    </Box>
                    {
                        selectedPostSurvey === '' &&
                        <TextField
                            autoFocus
                            required={false}
                            margin="dense"
                            id="name"
                            name="name"
                            label={
                                <label>
                                    <InsertPhotoOutlinedIcon /> <FormattedMessage id="post.survey.configuration.name" />
                                </label>
                            }
                            type="text"
                            fullWidth
                            variant="outlined"
                            error={false}
                            helperText={<FormattedMessage id="post.survey.configuration.name.description" />}
                            value={postSurveyName}
                            onChange={(e) => setPostSurveyName(e.target.value)}
                        />
                    }
                    <Box display="flex" gap={2}>
                        <TextField
                            autoFocus
                            required={false}
                            margin="dense"
                            id="image"
                            name="Image link"
                            label={
                                <label>
                                    <InsertPhotoOutlinedIcon /> <FormattedMessage id="post.survey.image.link" />
                                </label>
                            }
                            type="text"
                            fullWidth
                            variant="outlined"
                            error={false}
                            helperText={<FormattedMessage id="post.survey.image.link.description" />}
                            value={imageLink}
                            onChange={(e) => setImageLink(e.target.value)}
                        />
                        <TextField
                            autoFocus
                            required={false}
                            margin="dense"
                            id="image"
                            name="open image link"
                            label={
                                <label>
                                    <OpenInNewIcon /> <FormattedMessage id="post.survey.redirect.image.link" />
                                </label>
                            }
                            type="text"
                            fullWidth
                            variant="outlined"
                            error={false}
                            helperText={<FormattedMessage id="post.survey.redirect.image.link.description" />}
                            value={redirectLink}
                            onChange={(e) => setRedirectLink(e.target.value)}
                        />
                    </Box>
                    <Box display="flex" gap={2}>
                        <TextField
                            autoFocus
                            required={false}
                            margin="dense"
                            id="message"
                            name="message"
                            label={
                                <label>
                                    <MessageOutlinedIcon /> <FormattedMessage id="post.survey.message" />
                                </label>
                            }
                            type="text"
                            fullWidth
                            variant="outlined"
                            error={false}
                            helperText={<FormattedMessage id="post.survey.message.description" />}
                            value={message}
                            onChange={(e) => setMessage(e.target.value)}
                        />
                        <TextField
                            autoFocus
                            required={false}
                            margin="dense"
                            id="qr link"
                            name="qr link"
                            label={
                                <label>
                                    <QrCodeScannerIcon /> <FormattedMessage id="post.survey.qr" />
                                </label>
                            }
                            type="text"
                            fullWidth
                            variant="outlined"
                            error={false}
                            helperText={<FormattedMessage id="post.survey.qr.description" />}
                            value={qrLink}
                            onChange={(e) => setQrLink(e.target.value)}
                        />
                    </Box>
                    {(selectedPostSurvey !== '' || postSurveyName !== '') &&
                        <Box display="flex" justifyContent="center" alignItems="center" mt={2}>
                            <Link
                                onClick={handlePreview}
                                to={`/postsurveypreview`}
                                target='_blank'
                                rel="noopener noreferrer">
                                <Button
                                    variant="outlined"
                                    color="success"
                                    startIcon={<VisibilityOutlinedIcon />}
                                >
                                    <FormattedMessage id="post.survey.preview" />
                                </Button>
                            </Link>
                        </Box>
                    }
                    {isSending &&
                        <Box sx={{ width: '100%', marginTop: 2 }}>
                            <LinearProgress sx={{ borderRadius: "5px" }} />
                        </Box>
                    }
                </DialogContent>
                <DialogActions sx={{ justifyContent: 'center' }}>
                    <Button
                        variant="outlined"
                        color="error"
                        startIcon={<CloseOutlinedIcon />}
                        onClick={handleClose}
                    >
                        <FormattedMessage id="cancel" />
                    </Button>
                    <Button
                        variant="outlined"
                        color="primary"
                        startIcon={<SaveOutlinedIcon />}
                        onClick={handleSubmit}
                        disabled={isSending}
                        type="submit"
                    >
                        {isSending ?
                            <FormattedMessage id="saving" />
                            :
                            <FormattedMessage id="save" />
                        }
                    </Button>
                </DialogActions>
            </Dialog>
        </div>
    )
}
